import { type JSX } from 'react';
import { WifiOff } from 'lucide-react';
import { useOnline } from '../lib/offline/use-online.ts';

/** App-wide connectivity notice, mounted once in App.tsx so it covers every screen alike. */
export function OfflineBanner(): JSX.Element | null {
  const online = useOnline();
  if (online) return null;
  return (
    <div
      role="status"
      data-testid="offline-banner"
      className="flex items-center justify-center gap-2 bg-destructive px-4 py-2 text-center text-sm font-medium text-destructive-foreground"
    >
      <WifiOff className="h-4 w-4 shrink-0" aria-hidden="true" />
      <span>You’re offline. Check your internet connection. HapMetrix will reconnect automatically.</span>
    </div>
  );
}
